<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="50" width="50" viewBox="0 0 640 480">
        <g fill-rule="evenodd">
            <path fill="#fff" d="M640 480H0V0h640z"/>
            <path fill="#dc143c" d="M640 480H0V240h640z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "Pl"
    }
</script>

<style scoped>

</style>
